module.exports = "/_next/static/images/Check-f22dd0ff4df081f1b4120b88ea274adf.png";